import React from 'react';
import './iconButton.scss'

export const IconButtonComponent = ({icon, buttonText, buttonvariant, isDisabled, clickEvent = () => {}}) => {
    
    return (<button disabled={isDisabled} className={`button-class ${buttonvariant ? buttonvariant : ''}`} data-testid='button-container' aria-label={buttonText} variant='outlined' onClick={()=>{if(!isDisabled){clickEvent()}}}>
    {icon? <img src={icon} className='button-icon'/>: null }{buttonText}</button>)
}
